"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MobileNav = require("./MobileNav.styles");

var MobileNavFooter = function MobileNavFooter(_ref) {
  var secondaryLinks = _ref.secondaryLinks,
      actions = _ref.actions;
  // TODO: WHAT HAPPENS WHEN THERE ARE MORE ACTIONS AND/OR 2NDLINKS
  var login = secondaryLinks && secondaryLinks.length > 0 ? secondaryLinks[0] : null;
  var action = actions && actions.length > 0 ? actions[0] : null;
  return /*#__PURE__*/_react.default.createElement(_MobileNav.MenuFooter, null, login && /*#__PURE__*/_react.default.createElement(_MobileNav.MenuAction, null, /*#__PURE__*/_react.default.createElement(_MobileNav.ActionLink, {
    color: "black",
    to: login.url,
    onClick: login.onClick
  }, login.label)), action && /*#__PURE__*/_react.default.createElement(_MobileNav.MenuAction, {
    variant: "secondary"
  }, /*#__PURE__*/_react.default.createElement(_MobileNav.ActionLink, {
    color: "#fff",
    to: action.url,
    onClick: action.onClick
  }, action.label)));
};

MobileNavFooter.propTypes = {
  /** Array of objects defining Secondary Nav Menu (Actions Menu). onClick callback is optional but useful for implementing things like tracking */
  secondaryLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    url: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      description: _propTypes.default.string,
      label: _propTypes.default.string,
      url: _propTypes.default.string,
      onClick: _propTypes.default.func
    }))
  })),

  /** Array of objects defining Call to Actions (Buttons) */
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    url: _propTypes.default.string
  }))
};
MobileNavFooter.defaultProps = {
  actions: [],
  secondaryLinks: []
};
var _default = MobileNavFooter;
exports.default = _default;